import type { IntegrationQuotaReportApiData, IntegrationQuotaReportApiResponses } from '@navio/nsdk';

import { apiUrl, dataEndpoint } from '../defineResource';

export const getIntegrationQuotaUrls = {
  getIntegrationQuotas: dataEndpoint<IntegrationQuotaReportApiData, IntegrationQuotaReportApiResponses>({
    getUrl: () => apiUrl('integration-quotas/')
  })
};
